module.exports = __webpack_public_path__ + "img/connection-left-5.b94785be.png";